import React from 'react';
import { connect } from "react-redux";
import { Circle, Group, Stage, Layer, Rect, Line} from 'react-konva';

window.selectionColor = '#47413c';

const AutomationSelection = (props) => {
    if (props.selection === undefined) {
        return [];
    }
    let {x, y, height, width} = props.selection;
    return (
        <rect  className="automation-selection" x={x} y={y} height={height} width={width} fill={window.selectionColor}/>
    );
};

const mapStateToProps = (state, props) => {
    return {
        selection: state.automation.selection[props.track.id]
    };
};


export default connect(mapStateToProps, null)(AutomationSelection);
